import { useEffect, useState } from "react";
import { ISseImportInvalidateServices, ISseImportMsg } from "../../model/ISseImport";
import api, { IApiTags } from "../services/api";
import { setIsConnected, setLogMsg } from "../store/sseSlice";
import { useTypedDispatch } from "./useTypedDispatch";

const invalidateMap: Record<ISseImportInvalidateServices, IApiTags> = {
  'import': 'imports',
  'import/update-tracking-list/actual': 'actual-tracking-imports',
  'import/update-tracking-list/history': 'tracking-imports',
  'import/statistics': 'import-statistics',
};

export default function useImportSSE() {
  const dispatch = useTypedDispatch();

  // -- SSE connection state
  const [sseSource, setSseSource] = useState<EventSource>();

  // --
  // -- Open SSE connection
  const connect = () => {
    // const accessToken = StorageService.getToken('access');
    // const sseSource = new EventSource(`${process.env.REACT_APP_API_HOST}/sse/user?auth_token=${accessToken}`);
    // const sseSource = new EventSource(`${process.env.REACT_APP_API_HOST}sse/import-connect`);
    // setSseSource(() => sseSource);

    // -- fill SSE connection state
    setSseSource(() => new EventSource(`${process.env.REACT_APP_API_HOST}sse/import-connect`));
    // return sseSource;
  } 

  const start = () => {
    !sseSource && connect();
    // const sseSource = connect();   

    // sseSource.onopen = () =>  console.log(`[${new Date().toLocaleTimeString()}] SSE: Connection was opened`);

    // sseSource.onerror = () => console.log(`[${new Date().toLocaleTimeString()}] SSE: Connection error`);
    
    // sseSource.onmessage = async (event) => {      

    //   const msgParams = getMsgParams(event.data);
    //   console.log(`[${new Date().toLocaleTimeString()}] SSE: Incoming message:`, msgParams);

    //   // --
    //   // -- Invalidate URL if this marks exist
    //   msgParams?.invalidate?.length && invalidateApiTags(msgParams?.invalidate);
    // }
  };

  // --
  // -- When SSE is connected
  useEffect(() => {
    if (!!sseSource) {
      sseSource.onopen = () => {
        console.log(`[${new Date().toLocaleTimeString()}] SSE: Connection was opened`);
        dispatch(setLogMsg('Connected'));
        dispatch(setIsConnected(true));
      }
      sseSource.onerror = () => {
        console.log(`[${new Date().toLocaleTimeString()}] SSE: Connection error`);
        dispatch(setLogMsg('Connected ERROR'));        
        dispatch(setIsConnected(false));
      }
      sseSource.onmessage = async (event) => {
        const msgParams = getMsgParams(event.data);
        console.log(`[${new Date().toLocaleTimeString()}] SSE: Incoming message:`, msgParams);
        dispatch(setLogMsg(`${msgParams?.description || event.data}`));

        // --
        // -- Invalidate URL if this marks exist
        msgParams?.invalidate?.length && invalidateApiTags(msgParams?.invalidate);
      }
    }
  }, [!!sseSource]);

  const stop = () => {
    sseSource && console.log(`[${new Date().toLocaleTimeString()}] SSE: Connection was closed`);
    sseSource && sseSource.close();
    dispatch(setLogMsg('Connection was closed'));
    dispatch(setIsConnected(false));
  };

  // --
  // -- SSE message parsing
  const getMsgParams = (msgData: string): ISseImportMsg | undefined => {
    try {
      const msgParams = JSON.parse(msgData);
      if (msgParams) return msgParams as ISseImportMsg;
    } catch (err) {
      console.log(`[${new Date().toLocaleTimeString()}] SSE: Failed to parse message: ${msgData}`);      
    }
  }

  // --
  // -- Invalidate URLs
  const invalidateApiTags = (invalidates: ISseImportInvalidateServices[]) => {
    try {
      const tags = invalidates.reduce((acc, invalidate) => [
        ...acc,
        ...(invalidateMap?.[invalidate]
          ? [invalidateMap[invalidate]]
          : []
        )
      ], [] as IApiTags[])

      dispatch(api.util.invalidateTags(tags));
    } catch (err) {}
  }

  return {
    start,
    stop,
  };
}
